import { render, staticRenderFns } from "./customFieldBase.vue?vue&type=template&id=33e58ec9&scoped=true"
import script from "./customFieldBase.vue?vue&type=script&lang=js"
export * from "./customFieldBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e58ec9",
  null
  
)

export default component.exports